const setTooltipPosition = (btn, tooltip) => {
  let x = (btn.offsetLeft + btn.offsetWidth) - tooltip.offsetWidth;
  const caret = tooltip.querySelector('.tooltip-caret');
  if (x < 0) {
    // Offset caret
    caret.style.right = `${Math.abs(x) + 5}px`;
    // Reset x to 0
    x = 0;
  } else {
    caret.removeAttribute('style');
  }
  const y = btn.offsetTop - (tooltip.offsetHeight + 12);
  tooltip.style.left = `${x}px`;
  tooltip.style.top = `${y}px`;
};

const showTooltip = (event) => {
  const btn = event.target.closest('[data-tooltip-id]');
  if (btn === null) {
    return;
  }
  const id = btn.getAttribute('data-tooltip-id');
  const tooltip = document.getElementById(id);
  tooltip.classList.add('show');
  setTooltipPosition(btn, tooltip);
};

const hideTooltip = (event) => {
  const btn = event.target.closest('[data-tooltip-id]');
  if (btn === null) {
    return;
  }
  const id = btn.getAttribute('data-tooltip-id');
  const tooltip = document.getElementById(id);
  tooltip.classList.remove('show');
};

const toggleTooltip = (event) => {
  const btn = event.target.closest('[data-tooltip-id]');
  if (btn === null) {
    return;
  }
  const id = btn.getAttribute('data-tooltip-id');
  const tooltip = document.getElementById(id);
  if (tooltip.classList.contains('show')) {
    tooltip.classList.remove('show');
  } else {
    tooltip.classList.add('show');
  }
};

const addTooltipEventHandlers = (btn) => {
  btn.addEventListener('click', toggleTooltip);
  btn.addEventListener('mouseover', showTooltip);
  btn.addEventListener('mouseout', hideTooltip);
  btn.addEventListener('focus', showTooltip);
  btn.addEventListener('blur', hideTooltip);
};

const addTooltipsOnPageLoad = () => {
  const tooltipBtns = document.querySelectorAll('[data-tooltip-id]');
  if (tooltipBtns.length === 0) {
    return;
  }
  for (let i = 0; i < tooltipBtns.length; i++) { /* eslint-disable-line no-plusplus */
    addTooltipEventHandlers(tooltipBtns[i]);
  }
};

const addNewTooltipsToButtonGroup = (options) => {
  const { btns } = options;
  if (btns.length === 0) {
    return;
  }
  for (let i = 0; i < btns.length; i++) { /* eslint-disable-line no-plusplus */
    addTooltipEventHandlers(btns[i]);
  }
};

const addNewTooltipToButton = (options) => {
  const { btn } = options;
  addTooltipEventHandlers(btn);
};

export {
  addNewTooltipToButton,
  addNewTooltipsToButtonGroup,
  addTooltipsOnPageLoad,
};
